import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

import '~/style.sass'

const application = Application.start()
const controllers = import.meta.globEager('./../**/*_controller.js')
registerControllers(application, controllers)

import * as Turbo from '@hotwired/turbo'
Turbo.start()


document.addEventListener('turbo:submit-start', (event) => {
  console.log("turbo submit start", event.detail)

  if (document.location.pathname.includes('admin_area')) {
    console.log("ESCO")
    return true
  }

  var form = event.target

  var nodeToFill = form.querySelector('input[name="g-recaptcha-response"]')

  if (!nodeToFill) {
    console.log("nessun nodo anti spam; strano!", nodeToFill)
    return
  }

  if (nodeToFill.value) {
    console.log("anti spam già presente; strano!", nodeToFill)
    return
  }

  event.detail.formSubmission.stop()
  grecaptcha.execute('6LcCcjQpAAAAAF95aLbbMvTtIgmxbZCXaGXDrfwn', {action: 'submit'}).then(function(token) {
    nodeToFill.value = token
    event.target.querySelector('input[type="submit"]').click()
  });
})